Ext.define('SA.view.BusinessReportGrid', {
    alias: 'widget.business-report-grid',
    extend: 'SA.view.ReportGrid',

    listeners: {
        'column:click': function(grid, el, column) {
            var attribute = column.dataIndex;

            if (attribute !== 'rank') {
                grid.showColumnMenu(el, attribute);
            }
        },

        'column:mouseout': function(grid, td, column) {
            var dataIndex = column.dataIndex;

            if (dataIndex !== 'rank') {
                Ext.fly(td).removeCls('sa-grid-cell-over');
            }
        },

        'column:mouseover': function(grid, td, column) {
            var dataIndex = column.dataIndex;

            if (dataIndex !== 'rank') {
                Ext.fly(td).addCls('sa-grid-cell-over');
            }
        }
    },

    plugins: [{
        ptype: 'sa-grid-column-drag-reorder',

        afterMove(oldIndex, newIndex) {
            var grid = this.cmp,
                report = grid.projectView,
                attributes = report.getAttributes(),
                index = attributes.indexOf(this.dragColumn.dataIndex);

            report.moveAttribute(index, newIndex - oldIndex + index);

            report.save();
        }
    }],

    initComponent() {
        var reportModel = this.projectView;

        this.addCls('sa-business-report-grid');

        this.columns = this.buildColumns();
        this.data = [];

        this.callParent();

        this.refreshData();

        this.mon(reportModel, {
            buffer: 10,
            scope: this,

            'change:attribute': this.onChangeAttributes,
            'change:businessSearch': this.onChangeBusinessSearch,
            'change:loadstate': this.onChangeLoadState,
            'change:location': this.onChangeLocations,
            'change:sort': this.onChangeSort,
            'invoke:addAttribute': this.onAddAttributeInvokedOnView
        });
    },

    buildColumns() {
        var projectView = this.projectView,
            country = projectView.getCountry(),
            sortAttribute = projectView.getSortAttribute(),
            sortCls = 'sa-report-grid-sorted-' + projectView.getSortDirection(),
            configs = {
                'dba1':             {minAutoWidth: 150, forceRender: true},
                'dba2':             {minAutoWidth: 150, forceRender: true},
                'dba3':             {minAutoWidth: 150, forceRender: true},
                'dba4':             {minAutoWidth: 150, forceRender: true},
                'dba5':             {minAutoWidth: 150, forceRender: true},
                'city':             {minAutoWidth: 120, forceRender: true},
                'legal_name':       {minAutoWidth: 150, forceRender: true, locked: true},
                'lob':              {minAutoWidth: 150, forceRender: true},
                'status_indicator': {minAutoWidth: 130},
                'street_address':   {minAutoWidth: 150, forceRender: true},
                'url_domain':       {minAutoWidth: 180},

                'sales_volume_description':    {forceRender: true},
                'total_employees_description': {forceRender: true},
                'local_employees_description': {forceRender: true},
                'contact_1_title':             {forceRender: true},

                'point_id': {locked: true},

                'local_employees': {align: 'right'},
                'sales_volume':    {align: 'right'},
                'total_employees': {align: 'right'}
            };

        return [{
            align: 'right',
            dataIndex: 'rank',
            locked: true,
            text: '',
            width: 58
        }].concat(projectView.getAttributes().map(attribute => {
            return Object.assign({
                autoWidth: true,
                cls: attribute === sortAttribute ? sortCls : '',
                dataIndex: attribute,
                text: SA.data.BusinessSearchTableView.getColumnName(country, attribute)
            }, configs[attribute]);
        }));
    },

    onAddAttributeInvokedOnView() {
        Ext.widget({
            xtype: 'business-table-add-attribute-invoked-on-view-popup'
        });
    },

    onChangeAttributes() {
        this.refreshColumns();
        this.refreshData();
    },

    onChangeBusinessSearch() {
        this.refreshData();
    },

    onChangeLoadState({ isLoading }) {
        this.setLoading(isLoading);
    },

    onChangeLocations() {
        this.refreshData();
    },

    onChangeSort() {
        this.refreshColumns();
        this.refreshData();
    },

    refreshColumns() {
        this.setColumns(this.buildColumns());
    },

    refreshData() {
        var data = this.data,
            reportModel = this.projectView,
            dataMap = reportModel.getReportData({fn: this.refreshData, scope: this}),
            index = 0,
            rowCount = dataMap.total,
            numberFormat = Ext.util.Format.numberRenderer('0,000'),
            yesNoFormat = value => value.replace('Y', 'Yes').replace('N', 'No'),
            urlFormat = function(value) {
                return typeof value === 'string' ? value.toLowerCase() : value;
            },
            currencyFormat = function(value) {
                return '$' + numberFormat(value);
            },
            renderers = {
                'url_domain': urlFormat,
                'local_employees': numberFormat,
                'sales_volume': currencyFormat,
                'total_employees': numberFormat,
                'home_based': yesNoFormat
            };

        for ( ; index < rowCount ; ++index) {
            let row = data[index];

            if (!row) {
                row = {};

                data.push(row);
            }

            for (let attribute in dataMap) {
                let value = dataMap[attribute][index];

                if (value == null) {
                    value = '';
                }
                else {
                    let renderer = renderers[attribute];

                    if (renderer) {
                        value = renderer(value);
                    }
                }

                row[attribute] = value;
            }

            row.rank = index + 1;
        }

        if (rowCount == null) {
            this.setLoading(true);

            while (data.length < 2) {
                data.push({});
            }
        }
        else {
            this.setLoading(false);

            data.length = rowCount;
        }

        this.setData(data);
    },

    showColumnMenu(el, attribute) {
        var grid = this,
            items = [];

        if (grid.projectView.getSortAttribute() === attribute) {
            items.push({
                text: 'Reverse sort order',

                handler() {
                    var view = grid.projectView;

                    view.setSort(attribute, view.getSortDirection() === 'desc' ? 'asc' : 'desc');
                    view.save();
                }
            });
        }
        else {
            let text = SA.data.BusinessSearchTableView.isSizeAttribute(attribute)
                ? {asc: 'Sort, smallest to largest', desc: 'Sort, largest to smallest'}
                : {asc: 'Sort A-Z', desc: 'Sort Z-A'};

            items.push(
                {
                    disabled: grid.isLoading,
                    text: text.asc,

                    handler() {
                        var view = grid.projectView;

                        view.setSort(attribute, 'asc');
                        view.save();
                    }
                }, {
                    disabled: grid.isLoading,
                    text: text.desc,

                    handler() {
                        var view = grid.projectView;

                        view.setSort(attribute, 'desc');
                        view.save();
                    }
                }
            );
        }

        grid.showMenu({el, items, includeHeader: false});
    }
});
